/*
 * Module for the DirectDeposit/Edit view
*/

rs.module("ui/content/benefits/directdeposit/edit",

    [
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (selectHelper, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {
            var form = $.js(jsSelectors.form);
            var abaInput = form.js(jsSelectors.abaInput);
            var abaHiddenInput = form.js(jsSelectors.abaHiddenInput);
            var verifyLoadingSpinner = form.js(jsSelectors.verifyLoadingSpinner);
            var verifyCheck = form.js(jsSelectors.verifyCheck);
            var bankSelector = form.js(jsSelectors.bankSelector);
            var bankSelectorContainer = form.js(jsSelectors.bankSelectorContainer);
            var bankSelectHelper = selectHelper.getHelper(bankSelector);
            var accountNumber = form.js(jsSelectors.accountNumber);
            var verifyChangeButton = form.js(jsSelectors.verifyChangeButton);
            var depositPercent = form.js(jsSelectors.depositPercent, { required: false });
            var depositAmount = form.js(jsSelectors.depositAmount, { required: false });
            var confirmButton = form.js(jsSelectors.confirmButton);
            var loadingSpinner = form.js(jsSelectors.loadingSpinner);

            // Verify the routing number or reset the controls when clicked
            verifyChangeButton.click(function () {
                if (verifyChangeButton.text().trim() == "Verify") {

                    bankSelectHelper.setDisabled(false);
                    abaHiddenInput.val(abaInput.val());
                    verifyLoadingSpinner.show();

                    $.getJSON(
                        backendUrls.getFinancialInstitutions,
                        {
                            abaNumber: abaInput.val().trim()
                        }).always(function (){
                            verifyLoadingSpinner.hide();
                        }).done(function (options) {                            

                            if (options.length > 1) {
                                enableFormControls(false);
                                bankSelectHelper.replaceOptions(options, { withBlank: true });
                                showBankSelector(true);

                                abaInput.prop("disabled", true);
                                verifyChangeButton.text("Change");
                                verifyCheck.show();

                            } else if (options.length == 1) {
                                enableFormControls(true);
                                bankSelectHelper.replaceOptions(options);
                                showBankSelector(false);

                                abaInput.prop("disabled", true);
                                verifyChangeButton.text("Change");
                                verifyCheck.show();
                                eventBanner.removeAllMessages(); //remove the message about multiple banks if it is shown
                                bankSelectHelper.setValue(options[0].value); //there is only one option, so set the value for the selector

                            } else if (options.length == 0) {
                                enableFormControls(false);
                                bankSelectHelper.clearOptions();
                                showBankSelector(false);

                                abaInput.prop("disabled", false);
                                verifyChangeButton.text("Verify");
                                verifyCheck.hide();
                                bankSelectHelper.setValue(null);
                            }
                        });
                } else if (verifyChangeButton.text().trim() == "Change") {
                    enableFormControls(false);
                    bankSelectHelper.clearOptions();
                    showBankSelector(false);

                    abaInput.prop("disabled", false);
                    verifyChangeButton.text("Verify");
                    verifyCheck.hide();
                    eventBanner.removeAllMessages(); //remove the message about multiple banks if it is shown
                    $.validator.resetValidation(form); //reset the error message for the bank selector if shown
                }
            });

            // enable/disable form controls depending on the validity of the aba number
            function enableFormControls(enable) {
                // toggle all non-hidden inputs
                form.find("input").not("[type=hidden]").not($.js(jsSelectors.abaInput)).prop("disabled", !enable);
                depositChange();

                //toggle select helpers except bankSelector
                form.find("select").not($.js(jsSelectors.bankSelector)).each(function () {
                    selectHelper.getHelper($(this)).setDisabled(!enable);
                });

                confirmButton.setDisabled(!enable);
            }

            // show or hide the bank drop down selector
            function showBankSelector(show) {
                if (show) {
                    abaInput.addClass("dropdown-shown");
                    verifyChangeButton.addClass("dropdown-shown");
                    bankSelectorContainer.slideDown();
                } else { 
                    abaInput.removeClass("dropdown-shown");
                    verifyChangeButton.removeClass("dropdown-shown");
                    bankSelectorContainer.slideUp();
                }
            }

            // enable/disable form controls based on the bank selection
            bankSelector.change(function () {
                enableFormControls(bankSelector.val() != "");
            });

            depositPercent.on('input', depositChange);
            depositAmount.on('input', depositChange);


            // toggle enabled/disabled on deposit amount/percent inputs
            function depositChange() {
                if (depositPercent.val() && parseFloat(depositPercent.val().replace('%', '')) != 0.0) {
                    depositAmount.val("");
                    depositAmount.prop("disabled", true);
                } else if (depositAmount.val() && parseFloat(depositAmount.val().replace('$', '')) != 0.0) {
                    depositPercent.val("");
                    depositPercent.prop("disabled", true);
                } else {
                    depositAmount.prop("disabled", false);
                    depositPercent.prop("disabled", false);
                }
            }

            // make fields read only when we submit
            form.submit(function (e) {
                // Validate form before showing spinner and hiding fields
                var validator = $(this).validate();
                var isValid = validator.form();

                if (isValid) {
                    loadingSpinner.show();

                    // Prevent further interaction with the form
                    form.css("pointer-events", "none");
                    // Bootstrap's custom control toggles don't respond to pointer events, so manually unhook them
                    form.find("input").removeAttr("for");
                }
                else {
                    e.preventDefault();
                }
            })
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);